<template>
  <div class="container-arcada-superior">
    <div class="container-quadrante" :class="{ 'modo-primeiro-quadrante': visualizarQuadrantes }">
      <label v-if="visualizarQuadrantes">Quadrante 1</label>
      <div class="sub-container-arcada">
        <div v-for="dentePrimeiroQuadrante in dentesQuadrante1" :key="dentePrimeiroQuadrante.id"
             :id="'dente-' + dentePrimeiroQuadrante.id"
             class="dente-item container-primeiro-quadrante"
             @click="selecionarDente(dentePrimeiroQuadrante)"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <span>{{ dentePrimeiroQuadrante.numero }}</span>
                <odontograma-dente :imagem="dentePrimeiroQuadrante.foto"
                                   :possui-procedimentos="dentePrimeiroQuadrante.possuiProcedimentos"
                                   :possui-canal="dentePrimeiroQuadrante.possuiCanal"
                                   :foi-extraido="dentePrimeiroQuadrante.foiExtraido"
                                   :possui-restauracao="dentePrimeiroQuadrante.possuiRestauracao"
                />
              </div>
            </template>
            {{ dentePrimeiroQuadrante.nome }}
          </v-tooltip>
        </div>
      </div>
    </div>

    <div class="container-quadrante" :class="{ 'modo-segundo-quadrante': visualizarQuadrantes }">
      <label v-if="visualizarQuadrantes">Quadrante 2</label>
      <div class="sub-container-arcada">
        <div v-for="denteSegundoQuadrante in dentesQuadrante2" :key="denteSegundoQuadrante.id"
             :id="'dente-' + denteSegundoQuadrante.id"
             class="dente-item container-segundo-quadrante"
             @click="selecionarDente(denteSegundoQuadrante)"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <span>{{ denteSegundoQuadrante.numero }}</span>
                <odontograma-dente :imagem="denteSegundoQuadrante.foto"
                                   :possui-procedimentos="denteSegundoQuadrante.possuiProcedimentos"
                                   :possui-canal="denteSegundoQuadrante.possuiCanal"
                                   :foi-extraido="denteSegundoQuadrante.foiExtraido"
                                   :possui-restauracao="denteSegundoQuadrante.possuiRestauracao"
                />
              </div>
            </template>
            {{ denteSegundoQuadrante.nome }}
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OdontogramaDente from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaDente.vue'

export default {
    components: {OdontogramaDente},
    nome: 'OdontogramaArcadaSuperior',
    props: {
        visualizarQuadrantes: {
            type: Boolean,
            default: false
        },
        dentesQuadrante1: {
            type: Array,
            required: true
        },
        dentesQuadrante2: {
            type: Array,
            required: true
        },
    },
    data() {
        return {}
    },
    methods: {
        selecionarDente(dente) {
            this.$emit('selecionarDenteEvento', dente)
        }
    }
}
</script>

<style scoped lang="stylus">

.container-arcada-superior
  display flex
  flex-direction row
  justify-content center

.sub-container-arcada
  display flex
  flex-direction row
  justify-content center

.container-primeiro-quadrante, .container-segundo-quadrante
  text-align center

.dente-item:hover
  cursor pointer
  opacity 0.7

.container-quadrante
  text-align center

.modo-primeiro-quadrante
  background-color #C5E7E2
  border-bottom 1px solid black

.modo-segundo-quadrante
  background-color #A1CDA8
  border-left 1px solid black
  border-bottom 1px solid black

</style>